import React from "react";
import { compose } from "recompose";
import withTranslator from "../Translator/withTranslation";
import withFosRouter from "../FosRouter/withFosRouting";

class UnfinishedBookingComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            open: true
        };
    }
    
    dismiss = () => {
        // user doesn't have to wait for response
        this.setState({
            open: false
        });
    
        fetch(this.props.r('handle_unfinished_booking', {id: this.props.data.id, tcId: this.props.data.tcId, dismiss: true}))
            .then(data => {
                if (data.statusText === 'OK'){
                    // successfully removed
                }
        });
    }
    
    render() {
        if(!this.props.data || this.props.data.length === 0 || !this.state.open) return(null);
        const { t, r } = this.props;

        return (
            <div className={(this.props.className ? this.props.className : '')}>
                <div className="bg-orange3 p-3">
                    <div className="text-right">
                        
                    </div>
                    <div className="container">
                        <div className="row items-center px-4">
                            <div className="col-sm-7 mb-3 m-sm-0">
                            <div className={"font-w600 " +(this.props.mobile ? (this.props.tablet ? 'text-left' : 'text-center') : 'text-right') }>{t('unfinishedbooking.text1',{'villaname': this.props.data.accommodationName})}</div>
                            </div>
                            <div className="col-sm-3 col-7">
                                <a
                                href={r('handle_unfinished_booking', { id: this.props.data.id , tcId: this.props.data.tcId })}
                                className="btn btn-primary btn-block btn-sm" 
                                >{t('booknow')}</a>
                            </div>
                            <div className="col-sm-2 col-5">
                                <button
                                onClick={() => this.dismiss()}
                                className="btn btn-tertiary capitalize btn-sm"
                                >{t('close')}</button>
                            </div>
                        </div>
                    </div>
               </div>
           </div>
        );
    }
}

export const UnfinishedBooking = compose(
    withTranslator,
    withFosRouter)
(UnfinishedBookingComponent);